var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-2xl mb-6"},[_vm._v(" Basic Cards ")]),_c('card-basic'),_c('p',{staticClass:"text-2xl mt-14 mb-6"},[_vm._v(" Navigation Cards ")]),_c('card-navigation'),_c('p',{staticClass:"text-2xl mt-14 mb-6"},[_vm._v(" Solid Cards ")]),_c('card-solid')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }